/**
 * Talos gateway SPA entry point (Preact).
 */
import { render } from 'preact';
import { App } from './app.jsx';
import { getTheme, setTheme } from './lib/theme.js';
import { initFocusSync } from './lib/push.js';
import { getAuthStatus, setOIDCEnabled } from './lib/auth.js';

// Apply the persisted theme (defaults to 'light' when none is stored).
setTheme(getTheme());

// Register the push service worker and keep it informed of the focused session.
initFocusSync();

// Cache whether the gateway has OIDC auth enabled so the API client can
// redirect to login on 401 when a session expires.
getAuthStatus()
  .then((s) => setOIDCEnabled(!!s && !!s.oidc_enabled))
  .catch(() => {});

const root = document.getElementById('root');
if (root) {
  render(<App />, root);
}